import axios from 'axios'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import CreateAttachment from './dto/CreateAttachment'
import GetAllAttachments from './dto/GetAllAttachments'
import GetAttachment from './dto/GetAttachment'
import {PagedAttachmentResultRequestDto} from './dto/PagedAttachmentResultRequestDto'
import UpdateAttachment from './dto/UpdateAttachment'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/UserPrivateAttachment/Create`
export const URL_DELETE = `${API_URL}/UserPrivateAttachment/Delete`
export const URL_GET = `${API_URL}/UserPrivateAttachment/Get`
export const URL_GET_ALL = `${API_URL}/UserPrivateAttachment/GetPagedAll`
export const URL_UPDATE = `${API_URL}/UserPrivateAttachment/Update`

export function onCreateAttachment(createAttachment: CreateAttachment): Promise<boolean> {
  return axios.post(URL_CREATE, createAttachment)
}

export function onDeleteAttachment(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetAttachment(entityDto: EntityDto): Promise<GetAttachment> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllAttachments(
  pagedFilterAndSortedRequest: PagedAttachmentResultRequestDto
): Promise<PagedResultDto<GetAllAttachments>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateAttachment(updateAttachmentInput: UpdateAttachment): Promise<boolean> {
  return axios.put(URL_UPDATE, updateAttachmentInput)
}
